import PropTypes from "prop-types";
import { PageHeader } from "@/components/common/PageHeader";

export function MockDataRemovedPage({ title, description }) {
  return (
    <div className="flex flex-col h-full overflow-y-auto scrollbar-thin">
      <PageHeader title={title} description={description} />
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="max-w-md text-center rounded-xl border border-dashed border-slate-200 bg-slate-50/60 px-6 py-10">
          <div className="text-[15px] font-semibold text-slate-900">No sample data</div>
          <p className="mt-2 text-[13px] text-slate-600 leading-relaxed">
            Demo and placeholder content has been removed from this area.
            Connect your channels and start working — real data will appear here automatically.
          </p>
        </div>
      </div>
    </div>
  );
}

MockDataRemovedPage.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};
